import { trackAdjustEvent } from "./adjustTracker";
import { type ReproEventProps, trackReproEvent } from "./reproTracker";

export { EVENT_NAMES, type EventName } from "./eventNames";
export type { AdjustPlatform } from "./platform";
export type { ReproEventProps } from "./reproTracker";

export type TrackEventParams = {
  props?: ReproEventProps;
  source?: string;
};

/**
 * Repro と Adjust に同時にイベントを送信する統合エントリーポイント。
 *
 * - Repro: 常に送信（ネイティブアプリのみ）
 * - Adjust: ADJUST_TOKENS に定義済みのイベント・プラットフォームのみ送信
 */
export const trackEvent = (
  eventName: string,
  params?: TrackEventParams,
): void => {
  trackReproEvent(eventName, params?.props, params?.source);
  trackAdjustEvent(eventName);
};
